<template>
  <div>
    <Header :title="'文章管理'" />
    <ul class="detail-article">
      <li class="detail-title">{{ article.title }}</li>
      <li class="detail-more">
        <span>日期：{{ article.createdDate }}</span>
        <span>浏览：{{ article.browseTimes }}</span>
      </li>
      <li class="detail-content" v-html="article.content" />
      <li class="detail-btn">
        <div class="btn btn-cancel" @click="cancel">取消</div>
        <div class="btn btn-edit" @click="toEdit">编辑</div>
      </li>
    </ul>
    <ul v-if="article.isComment" class="detail-comment">
      <li class="comment-title">文章评论(共{{ article.commentCount }}条)</li>
      <li v-for="(item,index) of commentList" :key="index" class="comment-item">
        <ul>
          <li class="comment-up">
            <div class="comment-content">{{ item.content }}</div>
            <!--            <span class="comment-time gray">{{item.createdDate}}</span>-->
          </li>
          <li class="flex-row-between-center comment-down">
            <div class="flex-row-between-center">
              <div
                v-show="item.memberAvatar"
                class="comment-avatar"
                :style="{background: `url(${$resUrl(item.memberAvatar)})`, backgroundPosition:'center', backgroundSize:'cover'}"
              />
              <div v-show="!item.memberAvatar" class="comment-avatar" />
              <div class="comment-name gray">{{ item.name }}</div>
            </div>
            <div class="comment-time gray">{{ item.createdDate }}</div>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import Storage from '@/utils/storage'
import { GetArticleComment } from '@/api/Hall'
import Header from '@/components/Header/Index'

export default {
  name: 'Detail',
  components: {
    Header
  },
  data() {
    return {
      id: 0,
      article: {},
      commentList: []
    }
  },
  created() {
    this.article = Storage.localGet('articleDetail')
    this.id = this.$route.params.id
    this.getHallArticleCommentList()
  },
  methods: {
    cancel() {
      this.$router.back()
    },
    toEdit() {
      this.$router.push({
        name: 'manageHallArticleEdit',
        params: {
          id: this.article.id,
          hallId: this.$route.params.hallId
        }
      })
    },
    getHallArticleCommentList() {
      const data = {
        id: this.id,
        pageIndex: 1,
        pageSize: 10
      }
      GetArticleComment(data).then(res => {
        if (res.success) {
          this.commentList = res.data.rows
          // console.log(this.commentList)
        }
      })
    }
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.name === 'manageHallArticleDetail' && from.name === 'manageHallArticleEdit') {
      next(vm => {
        vm.$route.params.hallId = from.params.hallId
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-article {
  margin: 0 15px;

  .detail-title {
    font-size: 18px;
    padding: 13px 0;
    line-height: 24px;
    text-align: left;
    font-weight: bold;
    position: relative;
  }

  .detail-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    height: 2px;
    width: 15%;
    border-radius: 1px;
    background-color: $primary-color;
  }

  .detail-more {
    font-size: 12px;
    height: 30px;
    line-height: 30px;

    span {
      margin-right: 20px;
    }
  }

  .detail-content {
    font-size: 14px;
    //line-height: 20px;

    ::v-deep * {
      max-width: 92vw;
    }

    ::v-deep p {
      word-break: break-word;
    }

    ::v-deep .ql-align-center {
      text-align: center;
    }

    ::v-deep .ql-align-left {
      text-align: left;
    }

    ::v-deep .ql-align-right {
      text-align: right;
    }

    ::v-deep .ql-align-justify {
      text-align: justify;
    }
  }

  .detail-btn {
    height: 50px;
    margin: 40px 0;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: bold;
    text-align: center;

    .btn {
      width: 150px;
      height: 40px;
      line-height: 40px;
      border-radius: 5px;
      letter-spacing: 5px;
      text-indent: 5px;
    }

    .btn-cancel {
      color: $primary-color-bright;
      background: #fff;
    }

    .btn-edit {
      color: #fff;
      background: linear-gradient(to right, #f2a612, #f7c827);
    }
  }
}

.detail-comment {
  padding-bottom: 15px;
  margin: 0 15px;

  .comment-title {
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: bold;
  }

  .comment-item {
    position: relative;

    .comment-up {
      margin-top: 5px;
      line-height: 24px;

      .comment-content {
        word-wrap: break-word;
        font-size: 13px;
        font-weight: bold;
      }

      .comment-time {
        font-size: 11px;
      }
    }

    .comment-down {
      height: 40px;
      line-height: 40px;

      .comment-avatar {
        width: 20px;
        height: 20px;
        border-radius: 10px;
        background-image: url('~@/assets/images/avatar-default.png');
        background-size: cover;
        background-repeat: no-repeat;
      }

      .comment-name {
        margin-left: 5px;
        font-size: 13px;
      }

      .comment-time {
        font-size: 11px;
      }

      .edit {
        font-size: 13px;
      }

      .icon-edit {
        font-size: 15px;
      }
    }
  }

  .comment-item:nth-last-child(n + 2)::after {
    content: '';
    position: absolute;
    left: 0;
    top: auto;
    bottom: 0;
    right: 0;
    height: 1px;
    width: 100%;
    background-color: #f0f0f0;
  }
}
</style>
